(function () {
  if (window.__reelmeMobileSwipe) return;
  window.__reelmeMobileSwipe = true;

  var MOBILE = '(max-width: 991px)';
  var GAP = 15;
  var SWIPE_MIN = 40;
  var DURATION = 350;
  var EASE = 'transform 0.35s ease';
  var STYLE_ID = 'reelme-mobile-swipe-style';
  var NAV = '[data-carousel-prev],[data-carousel-next]';

  var CSS =
    '[data-slides-container]>div{display:contents!important}' +
    '[data-reelme-shadow-content]>div{padding-left:0!important;padding-right:0!important}' +
    '@media (max-width: 991px){' +
      NAV + '{' +
        'opacity:0!important;clip-path:inset(50%)!important;' +
        'pointer-events:none!important;transform:scale(0)!important}' +
      '[data-carousel-container]{touch-action:pan-y!important}' +
    '}' +
    '@media (min-width: 992px){' +
      NAV + '{opacity:1!important;cursor:pointer!important}' +
    '}';

  var HOST_CSS =
    '[data-reelme-wrap]{padding-left:0!important;padding-right:0!important}' +
    '[data-reelme-block]{margin-inline:0!important}';

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  function hosts() {
    return document.querySelectorAll('.reelme-gallery-container[data-reelme-mount]');
  }

  function state(host) {
    if (!host.__reelmeState) host.__reelmeState = { pos: 0, busy: false, settleAt: 0 };
    return host.__reelmeState;
  }

  function settling(st) {
    return st.busy || Date.now() < st.settleAt;
  }

  function injectStyle(root) {
    if (!root || root.getElementById(STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = CSS;
    root.appendChild(el);
  }

  function fixLayout(host) {
    if (host.__reelmeLayoutFixed) return;
    host.__reelmeLayoutFixed = true;

    if (!document.getElementById(STYLE_ID)) {
      var sheet = document.createElement('style');
      sheet.id = STYLE_ID;
      sheet.textContent = HOST_CSS;
      document.head.appendChild(sheet);
    }

    var block = host.closest('.shopify-app-block') || host.parentElement;
    if (block) block.setAttribute('data-reelme-block', 'true');

    var wrap = host.closest('.stretch-padding');
    if (wrap) wrap.setAttribute('data-reelme-wrap', 'true');
  }

  function enableNav(root) {
    root.querySelectorAll(NAV).forEach(function (btn) {
      if (btn.disabled) btn.disabled = false;
    });
  }

  function divChildren(el) {
    return Array.prototype.filter.call(el.children, function (c) {
      return c.tagName === 'DIV';
    });
  }

  function metrics(track) {
    var groups = Array.prototype.filter.call(track.children, function (g) {
      return g.tagName === 'DIV' && !g.hasAttribute('data-reelme-loop');
    });
    if (!groups.length) return null;

    var items = [];
    groups.forEach(function (g) {
      items = items.concat(divChildren(g));
    });
    if (!items.length) return null;

    var width = items[0].getBoundingClientRect().width;
    if (!width) return null;

    return {
      items: items,
      total: items.length,
      per: divChildren(groups[0]).length || 1,
      step: width + GAP
    };
  }

  function syncClones(track, m) {
    var loop = track.querySelector('[data-reelme-loop]');
    var need = Math.min(m.per, m.total);

    if (loop && Number(loop.getAttribute('data-reelme-loop')) === need && loop.children.length === need) {
      return;
    }
    if (loop) loop.remove();

    loop = document.createElement('div');
    loop.setAttribute('data-reelme-loop', String(need));

    for (var i = 0; i < need; i++) {
      var clone = m.items[i].cloneNode(true);
      clone.removeAttribute('data-carousel-item-index');
      clone.setAttribute('data-reelme-clone', 'true');
      clone.querySelectorAll('[data-reelme-video-id]').forEach(function (el) {
        el.removeAttribute('data-reelme-video-id');
      });
      clone.querySelectorAll('video').forEach(function (video) {
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      });
      loop.appendChild(clone);
    }

    track.appendChild(loop);
  }

  function place(track, pos, step, animate, st) {
    track.style.transition = animate ? EASE : 'none';
    track.style.transform = 'translateX(' + -(pos * step) + 'px)';
    if (!animate) void track.offsetWidth;
    if (st && animate) st.settleAt = Date.now() + DURATION + 50;
  }

  function go(host, root, dir) {
    var st = state(host);
    if (st.busy) return;

    var track = root.querySelector('[data-slides-container]');
    if (!track) return;

    var m = metrics(track);
    if (!m) return;

    syncClones(track, m);

    var maxPos = Math.max(0, m.total - m.per);
    var pos = Math.min(st.pos, maxPos);

    if (dir > 0 && pos >= maxPos) {
      st.busy = true;
      st.pos = 0;
      place(track, m.total, m.step, true, st);
      setTimeout(function () {
        place(track, 0, m.step, false, st);
        st.busy = false;
      }, DURATION + 30);
      return;
    }

    if (dir < 0 && pos <= 0) {
      st.pos = maxPos;
      place(track, m.total, m.step, false, st);
      place(track, maxPos, m.step, true, st);
      return;
    }

    st.pos = dir > 0 ? Math.min(maxPos, pos + m.per) : Math.max(0, pos - m.per);
    place(track, st.pos, m.step, true, st);
  }

  function bindNav(host, root) {
    if (host.__reelmeNavBound) return;
    host.__reelmeNavBound = true;

    root.addEventListener('click', function (e) {
      var el = e.target;
      var btn = el && el.closest ? el.closest(NAV) : null;
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      go(host, root, btn.hasAttribute('data-carousel-next') ? 1 : -1);
    }, true);
  }

  function blockTapAfterSwipe(host) {
    var stop = function (e) {
      e.stopPropagation();
      e.preventDefault();
    };
    host.addEventListener('click', stop, true);
    setTimeout(function () {
      host.removeEventListener('click', stop, true);
    }, 400);
  }

  function bindSwipe(host) {
    if (host.__reelmeSwipeBound) return;
    host.__reelmeSwipeBound = true;

    var startX = 0;
    var startY = 0;
    var dx = 0;
    var axis = null;
    var track = null;
    var step = 0;
    var origin = 0;
    var active = false;

    host.addEventListener('touchstart', function (e) {
      if (!isMobile() || e.touches.length !== 1) return;

      var root = host.shadowRoot;
      if (!root || state(host).busy) return;

      track = root.querySelector('[data-slides-container]');
      if (!track) return;

      var m = metrics(track);
      if (!m) return;

      syncClones(track, m);
      step = m.step;
      origin = Math.min(state(host).pos, Math.max(0, m.total - m.per));
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      axis = null;
      active = true;
    }, { passive: true });

    host.addEventListener('touchmove', function (e) {
      if (!active || !track) return;

      var touch = e.touches[0];
      dx = touch.clientX - startX;
      var dy = touch.clientY - startY;

      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }

      if (axis !== 'x') return;
      if (e.cancelable) e.preventDefault();

      track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-(origin * step) + dx) + 'px)';
    }, { passive: false });

    function release() {
      if (!active) return;
      active = false;

      var swiped = axis === 'x' && Math.abs(dx) > SWIPE_MIN;
      axis = null;

      if (!track) return;

      if (swiped) {
        place(track, origin, step, false, null);
        go(host, host.shadowRoot, dx < 0 ? 1 : -1);
        blockTapAfterSwipe(host);
      } else {
        place(track, origin, step, true, state(host));
      }

      track = null;
    }

    host.addEventListener('touchend', release, { passive: true });
    host.addEventListener('touchcancel', release, { passive: true });
  }

  function refresh(host, root) {
    var st = state(host);
    if (settling(st)) return;

    var track = root.querySelector('[data-slides-container]');
    if (!track) return;

    var m = metrics(track);
    if (!m) return;

    syncClones(track, m);

    st.pos = Math.min(st.pos, Math.max(0, m.total - m.per));
    place(track, st.pos, m.step, false, null);
  }

  function watchRoot(host, root) {
    if (host.__reelmeRootWatched) return;
    host.__reelmeRootWatched = true;

    var queued = false;
    new MutationObserver(function () {
      if (queued || settling(state(host))) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        injectStyle(root);
        enableNav(root);
        refresh(host, root);
      });
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    var timeout;
    window.addEventListener('resize', function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        refresh(host, root);
      }, 200);
    }, { passive: true });
  }

  function setup() {
    var ready = 0;
    hosts().forEach(function (host) {
      fixLayout(host);
      bindSwipe(host);

      var root = host.shadowRoot;
      if (!root) return;

      injectStyle(root);

      if (root.querySelector('[data-carousel-next]') && root.querySelector('[data-slides-container]')) {
        bindNav(host, root);
        enableNav(root);
        watchRoot(host, root);
        refresh(host, root);
        ready++;
      }
    });
    return ready;
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (setup() > 0 || tries > 160) clearInterval(timer);
  }, 250);

  setup();
  document.addEventListener('shopify:section:load', setup);
})();
